// extracted by mini-css-extract-plugin
export var questionBox = "_9n-0";